export const API_URL = process.env.NEXT_PUBLIC_API_URL ?? "";

export const LOGIN_PATH = "/login";

export const TOKEN_COOKIE_NAME = "gimir_token";
